import React from "react";

import { Subscribe } from "unstated";

import { ProfileContainer } from "./containers/profile-container";

import { Form, Field } from "react-final-form";

import { FORM_ERROR } from "final-form";

import { TextInput } from "../components/ui/text-input";
import { FormErrors } from "../components/ui/form-errors";

import { PasswordToggle } from "./ui/password-toggle";

import _ from "lodash";
import toast from 'react-hot-toast';

import {
  required,
  composeField,
  passwordConfirmation,
  composeForm
} from "../lib/form-validators";

const PasswordUpdate = () => {
  const onSubmit = (profileContainer) => async (values, form) =>
    profileContainer
      .changePassword(values.password, values.currentPassword)
      .then(() => {
        form.reset();
        toast.success('Update password successfully!!!')
      })
      .catch(() => {
        return { [FORM_ERROR]: "Failed to update password" };
      });

  return (
    <div className="container">
      <Subscribe to={[ProfileContainer]}>
        {(profileContainer) => (
          <Form
            validate={composeForm(
              passwordConfirmation("password", "password_confirmation")
            )}
            onSubmit={onSubmit(profileContainer)}
            render={({
              handleSubmit,
              submitting,
              submitError,
              dirtySinceLastSubmit
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="row" id="userPassword">
                  <div className="col-md-6">
                    <Field
                      name="password"
                      validate={composeField(required)}
                      render={TextInput}
                      placeholder="Password"
                      type="password"
                      appendValue={(input) => (
                        <PasswordToggle inputRef={input} />
                      )}
                    />
                  </div>
                  <div className="col-md-6" />
                  <div className="col-md-6">
                    <Field
                      name="password_confirmation"
                      validate={composeField(required)}
                      render={TextInput}
                      placeholder="Confirm Password"
                      type="password"
                      appendValue={(input) => (
                        <PasswordToggle inputRef={input} />
                      )}
                    />
                  </div>
                  <div className="col-md-6">
                    <Field
                      name="currentPassword"
                      validate={composeField(required)}
                      render={TextInput}
                      placeholder="Current Password"
                      type="password"
                      appendValue={(input) => (
                        <PasswordToggle inputRef={input} />
                      )}
                    />
                  </div>
                  <div className="col-sm-12">
                    <FormErrors
                      submitError={submitError}
                      dirtySinceLastSubmit={dirtySinceLastSubmit}
                    />
                  </div>
                  <div className="col-sm-12 text-center mt-4">
                    <button
                      className="btn btn-primary btn-wide"
                      disabled={submitting}>
                      UPDATE
                    </button>
                  </div>
                </div>
              </form>
            )}
          />
        )}
      </Subscribe>
    </div>
  );
};

export { PasswordUpdate };
